
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/courtroomSlice";
import { removeMultipleCourtrooms } from "slices/courtroomSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { usePermissions } from "layouts/Admin";
import { fetchCourtrooms } from "slices/courtroomSlice";
import { courtroomSelector } from "slices/courtroomSlice";
import AddCourtrooms from "components/courtroom/AddCourtroom";
import { convertTimeToUTCFormatted } from "helpers/convertTimeToUTC";

const apiService = new Api();

function CourtroomsList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { courtroom: courtroom, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(courtroomSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  React.useEffect(() => {
    dispatch(fetchCourtrooms())
  }, [])

  const handleAddLocationPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchCourtrooms())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleCourtrooms({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(courtroom?.map((courtroom) => courtroom.id.toString()))


  }

  const handleClose = () => {
    refAddutton.current.click(); setAddForm({ show: false })
  };

  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchCourtrooms(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }

    return (
      <tr>
        <th >
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Courtrooms') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th >
          <TableHeaderItem
            title="Courtroom"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>


        <th>
          <TableHeaderItem
            title="Zoom "
            sortBy="zoom"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>


        <th >
          <TableHeaderItem
            title="Zoom Link"
            sortBy="zoom_link"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>


        <th >
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Status Courtrooms') &&
          <th >Status</th>
        }
        {checkPermission('Edit Courtrooms') &&
          <th >Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      courtroom?.map((courtroom, index) => (
        <CourtoomItems courtroom={courtroom} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddLocationPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [courtroom, selectedItems]);

  //#endregion


  return (
    <ListLayout
      heading="Courtrooms"
      time={true}
      title=""
      buttonTitle="Add courtroom"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      // TODO: change loation permission with currect keyword 
      addButtonDisabled={!checkPermission('Create Courtrooms')}
      totalPages={totalPages}
      fetchList={fetchCourtrooms}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddCourtrooms item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} statusPerm={checkPermission('Status Cities')} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddLocationPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search courtroom..."
      noOfItems={total}

    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const CourtoomItems = ({
  courtroom, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(courtroom?.status);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }

  React.useEffect(() => {
    setStatus(courtroom?.status)

  }, [courtroom])

  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#f4f4f4' } : {};
  };
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);
  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Courtrooms') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={courtroom.id} checked={selectedItems.includes(courtroom.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {courtroom.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {courtroom.zoom_link ? 'Yes' : 'No'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {courtroom.zoom_link || '-'}
      </td>
      <td style={getBackgroundStyle(status)}>
        {convertTimeToUTCFormatted(courtroom.created_at)}
      </td>
      {checkPermission('Status Courtrooms') &&
        <td style={getBackgroundStyle(status)}>
          <CustomSwitch handleChange={(status) => handleStatusChange(courtroom?.id, status)} checked={status == 1 ? true : false} />
        </td>
      }
      {checkPermission('Edit Courtrooms') &&
        <td style={getBackgroundStyle(status)}>
          <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleAddPopUp({ ...courtroom, status })}>Edit</button>
        </td>
      }
    </tr>
  )
}


export default CourtroomsList;
